// extracted by mini-css-extract-plugin
export default {"permissions-select":"style_permissions-select__7DYaa"};